import MultipleCheckboxFacets from './MultipleCheckboxFacets';
export default MultipleCheckboxFacets;
